import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=3bbeb451"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=3bbeb451&prod&lang=css"
import style1 from "./AdminLayout.vue?vue&type=style&index=1&id=3bbeb451&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports